import $ from 'jquery';


class RegistrationProfile {
	
	constructor() {
		if ($("#registration-profile").length > 0) {
			this.init();
		}
	}

	init() {
		
		Vue.component('profile-editor',  () => import('../components/ProfileEditor.vue'));

	}

}

export default RegistrationProfile;
